<template>
    <div>
        <loading-container v-if="loading"/>

        <div v-else>
            <headline-container :headline="page.attributes.title" :breadcrumbs="breadcrumbs"/>

            <div class="container">
                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Blocks
                            </h3>

                            <p>
                                This list displays the blocks that exist in the page.
                            </p>

                            <router-link
                                    :to="'/marketing-sites/' + portal.id + '/pages/' + page.id + '/blocks/create'"
                                    class="btn btn-black btn-sm"
                            >
                                <i class="fa fa-plus"></i> New
                            </router-link>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <block-list-panel :portal="portal" :page="page" :block-types="blockTypes"/>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Edit Page
                            </h3>

                            <p>
                                In this form, you may change the details of the page.
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <form-panel :value="page.attributes" :errors="errors" @submit="update"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import BlockListPanel from '@/components/Panels/Administration/MarketingSites/Blocks/List'
    import Errors from '@/mixins/Errors'
    import FormPanel from '@/components/Panels/Administration/MarketingSites/Pages/Form'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import LoadingContainer from '@/components/Layout/LoadingContainer'

    export default {
        components: {BlockListPanel, FormPanel, HeadlineContainer, HelpText, LoadingContainer},

        mixins: [Errors],

        props: {
            portalId: {
                required: true
            },

            pageId: {
                required: true
            }
        },

        data() {
            return {
                portal: null,
                page: null,
                blockTypes: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            breadcrumbs() {
                return [
                    {url: '/marketing-sites', text: 'Marketing Sites'},
                    {url: '/marketing-sites/' + this.portal.id, text: this.portal.attributes.name},
                    {text: this.page.attributes.title}
                ]
            }
        },

        methods: {
            load() {
                Promise.all([
                    http.get('/api/v2/portals/' + this.portalId),
                    http.get('/api/v2/marketing-site-pages/' + this.pageId),
                    http.get('/api/v2/marketing-site-block-types')
                ])
                    .then(responses => {
                        this.portal = responses[0].data.data

                        this.page = responses[1].data.data

                        this.blockTypes = responses[2].data.data

                        this.loading = false
                    })
            },

            update(data) {
                http.put('/api/v2/marketing-site-pages/' + this.pageId, data)
                    .then(response => {
                        this.errors = {}

                        this.page = response.data.data

                        notify.success('The page was saved')
                    }).catch(this.catchValidationErrors)
            }
        }
    }
</script>
